export default __webpack_public_path__ + "static/media/screenshot-04.4dcdeb8d.png";